export default __webpack_public_path__ + "static/media/q.350290da.glb";